import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import portugues from 'vuetify/lib/locale/pt'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { portugues },
    current: 'portugues',
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        bluePcm: '#283593',
        orangePcm: '#F57C00',
        background: '#fbfbfb',
        monitorText: '#1c1c1c',
        white: '#fff',

        lightRed: '#EF5350',
        red: '#F44336',
        darkRed: '#d50000',
        lightenBlue: '#d5ddf2',
        lightBlue: '#42A5F5',
        blue: '#2196F3',
        darkBlue: '#1E88E5',
        lightGreen: '#66BB6A',
        green: '#4CAF50',
        yellow: '#fdd835',
        darkYellow: '#FBC02D',

        lightGray: '#c2c2c2',
        gray: '#757575',
        darkGray: '#454647',
        darkenGray: '#151515',
      },
    },
  },
})
